module.exports = __webpack_public_path__ + "img/Monthlywage.44341b48.svg";